import React, { useEffect, useState } from "react";

const TARGET = new Date("2026-07-26T23:59:59+05:30").getTime();

function calc() {
  const diff = TARGET - Date.now();
  if (diff <= 0) return null;
  return {
    days: String(Math.floor(diff / 86400000)).padStart(2, "0"),
    hours: String(Math.floor((diff / 3600000) % 24)).padStart(2, "0"),
    mins: String(Math.floor((diff / 60000) % 60)).padStart(2, "0"),
    secs: String(Math.floor((diff / 1000) % 60)).padStart(2, "0"),
  };
}

export default function Countdown({ dark = false }) {
  const [t, setT] = useState(calc());
  useEffect(() => {
    const i = setInterval(() => setT(calc()), 1000);
    return () => clearInterval(i);
  }, []);
  if (!t) return null;
  const Unit = ({ v, label }) => (
    <div className="flex flex-col items-center">
      <div className={`flip-card font-display font-bold text-2xl md:text-4xl w-14 md:w-20 h-14 md:h-20 flex items-center justify-center rounded-xl ${dark ? "bg-[#0F172A] text-white" : "bg-[#0F172A] text-white"}`}>
        <span key={v} className="block animate-[fadeIn_.4s_ease]">{v}</span>
      </div>
      <div className={`text-[10px] md:text-xs mt-2 tracking-widest uppercase ${dark ? "text-slate-300" : "text-[#0F172A]/80"}`}>{label}</div>
    </div>
  );
  return (
    <div className="flex items-center gap-3 md:gap-5">
      <Unit v={t.days} label="Days"/>
      <span className={`font-display text-2xl md:text-4xl ${dark ? "text-white" : "text-[#0F172A]"}`}>:</span>
      <Unit v={t.hours} label="Hours"/>
      <span className={`font-display text-2xl md:text-4xl ${dark ? "text-white" : "text-[#0F172A]"}`}>:</span>
      <Unit v={t.mins} label="Minutes"/>
      <span className={`font-display text-2xl md:text-4xl ${dark ? "text-white" : "text-[#0F172A]"}`}>:</span>
      <Unit v={t.secs} label="Seconds"/>
    </div>
  );
}
